import * as React from "react";
import type { SVGProps } from "react";
const SvgSelected = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={34}
    height={35}
    fill="none"
    {...props}
  >
    <path
      fill="#18A09F"
      d="M17 .897C8.04.897.75 8.473.75 17.785c0 9.311 7.29 16.887 16.25 16.887s16.25-7.575 16.25-16.887S25.96.897 17 .897m8.457 11.228-10.5 12.99a1.3 1.3 0 0 1-.42.338c-.162.08-.338.123-.518.126H14a1.2 1.2 0 0 1-.509-.113 1.25 1.25 0 0 1-.42-.317l-4.5-5.196a1.345 1.345 0 0 1-.222-1.444q.107-.237.295-.413a1.207 1.207 0 0 1 1.394-.197q.226.117.39.316l3.539 4.086 9.577-11.847a1.22 1.22 0 0 1 1.75-.145 1.334 1.334 0 0 1 .165 1.816"
    />
  </svg>
);
export default SvgSelected;
